import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { funnelReportsRunIdAppGroupIdStatus } from "./constants";
import type { GlobalFunnelRun, GlobalFunnelRunParams } from "./types";
import { isGlobalFunnelRun } from "./validators";

export const getGlobalFunnelRun = reactQueryFetcherAdapter(
  funnelReportsRunIdAppGroupIdStatus,
  (signal: AbortSignal, { runId, appGroupId }: GlobalFunnelRunParams): Promise<GlobalFunnelRun> =>
    fetch(
      `/funnel_reports/${runId}/${appGroupId}/status`,
      "GET",
      {},
      { signal },
      {
        propagateFetchRequestError: false,
      }
    ),
  isGlobalFunnelRun
);
